<template>
    <div id="log-component">
        <vs-table :data="logList" :max-items="itemsPerPage">
            <div slot="header" class="w-full">
                <div class="flex justify-between date-picker-row">
                    <date-picker class="date-picker-w-custom" range-separator="  to  " :format="date_format_string" v-model="in_day" type="date" :editable = "false" range placeholder="Date InFrom"></date-picker>
                    <date-picker class="date-picker-w-custom" range-separator="  to  " :format="date_format_string" v-model="out_day" type="date" :editable = "false" range placeholder="Date OutFrom"></date-picker>
                    <date-picker class="date-picker-w-custom" range-separator="  to  " :format="date_format_string" v-model="added_day" type="date" :editable = "false" range placeholder="Date Added"></date-picker>
                </div>
                <div class="flex flex-wrap-reverse items-center flex-grow justify-between mb-2">
                    <div class="flex add-delete log-add-delete">
                        <vs-button class="export-btn gradient gradient-primary no-shadow mb-4">Export</vs-button>
                        <vs-dropdown vs-trigger-click class="cursor-pointer item-per-page-dropdown mb-4 filter-type">
                            <div class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                            <span class="mr-2">{{filterType.name}}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu style="width: 100px;">
                                <vs-dropdown-item v-for="(item, i) in typeList" :key="i" @click="filterType = item">
                                    <span class="w-full flex justify-between" :class="{'text-primary': filterType.id == item.id}">
                                        {{item.name}}
                                        <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="filterType.id == item.id"/>
                                    </span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>

                    <div class="flex perpage-search">
                        <vs-dropdown vs-trigger-click class="cursor-pointer item-per-page-dropdown mb-4 mr-4">
                            <div class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" style="min-width: 150px">
                            <span class="mr-2">{{filterStaff.name}}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu style="width: 100px;">
                                <vs-dropdown-item v-for="(item, i) in staffList" :key="i" @click="filterStaff = item">
                                    <span class="w-full flex justify-between" :class="{'text-primary': filterStaff.id == item.id}">
                                        {{item.name}}
                                        <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="filterStaff.id == item.id"/>
                                    </span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>

                        <vs-dropdown vs-trigger-click class="cursor-pointer item-per-page-dropdown mb-4">
                            <div class="px-4 border border-solid d-theme-border-grey-light rounded-item d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium" style="min-width: 150px">
                            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ totalPage - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : totalPage }} of {{ totalPage }}</span>
                                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                            </div>
                            <vs-dropdown-menu style="width: 100px;">
                                <vs-dropdown-item v-for="(item, i) in options" :key="i" @click="changeItemsPerPage(currentPage = 1, itemsPerPage=item)" v-model="itemsPerPage">
                                    <span class="w-full flex justify-between" :class="{'text-primary': itemsPerPage == item}">
                                        {{item}}
                                        <feather-icon icon="CheckIcon" svgClasses="h-3 w-3 ml-2" v-if="itemsPerPage == item"/>
                                    </span>
                                </vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                        <div class="con-input-search vs-table--search mb-4">
                            <input type="text" class="input-search vs-table--search-input" placeholder="Search by phone..."/>
                            <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                        </div>
                    </div>
                </div>
            </div>
            <template slot="thead">
                <vs-th class="center-title text-center">Num</vs-th>
                <vs-th class="center-title text-center">Staff</vs-th>
                <vs-th class="center-title text-center">Type</vs-th>
                <vs-th class="center-title text-center">Time</vs-th>
                <vs-th class="center-title text-center">Created At</vs-th>
            </template>
            <template slot-scope="{data}">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data" class="shadow-md">
                    <vs-td class="text-center">{{ indextr }}</vs-td>
                    <vs-td class="text-center break-word" style="min-width: 100px;" :data="data[indextr].name">{{ tr.name }}</vs-td>
                    <vs-td class="text-center" :data="data[indextr].type">{{ tr.type }}</vs-td>
                    <vs-td class="text-center" :data="data[indextr].time">{{ tr.time }}</vs-td>
                    <vs-td class="text-center" :data="data[indextr].created_at">{{ tr.created_at }}</vs-td>
                </vs-tr>
            </template>
        </vs-table>

        <div>
            <custom-pagination class="custom-pagination mt-6" :totalPages="parseInt(totalPage)" :currentPage="currentPage" @pageChanged="changePage" :key="page_key"></custom-pagination>
        </div>
    </div>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { formatDateString } from '../../helper/datetimeHelper';
export default {
    name: 'log-component',
    components: { DatePicker },
    data() {
        let date_format_string = formatDateString();
        return {
            currentPage: 1,
            itemsPerPage: 10,
            totalPage: 3,
            logList: [
                {
                    id: 1,
                    name: 'David',
                    type: 'In',
                    time: '09/10/2020 01:00',
                    created_at: '09/09/2020 04:00'
                },
                {
                    id: 2,
                    name: 'Melanie Oliver',
                    type: 'In',
                    time: '09/10/2020 01:00',
                    created_at: '09/09/2020 04:00'
                },
                {
                    id: 3,
                    name: 'jess',
                    type: 'Out',
                    time: '09/10/2020 01:00',
                    created_at: '09/09/2020 04:00'
                },
                {
                    id: 4,
                    name: 'Lilly',
                    type: 'In',
                    time: '09/10/2020 01:00',
                    created_at: '09/09/2020 04:00'
                },
                {
                    id: 5,
                    name: 'David',
                    type: 'Out',
                    time: '09/10/2020 01:00',
                    created_at: '09/09/2020 04:00'
                },
                {
                    id: 6,
                    name: 'Melanie Oliver',
                    type: 'In',
                    time: '09/10/2020 01:00',
                    created_at: '09/09/2020 04:00'
                },
                {
                    id: 7,
                    name: 'jess',
                    type: 'Out',
                    time: '09/10/2020 01:00',
                    created_at: '09/09/2020 04:00'
                },
                {
                    id: 8,
                    name: 'Lilly',
                    type: 'Out',
                    time: '09/10/2020 01:00',
                    created_at: '09/09/2020 04:00'
                }
            ],
            deleteSelect: [],
            options: [ 10,15,20],
            in_day: [],
            out_day: [],
            added_day: [],
            staffList: [
                {id: 0, name: 'All staff'},
                {id: 1, name: 'Staff 1'},
                {id: 2, name: 'Staff 2'},
                {id: 3, name: 'Staff 3'},
            ],
            filterStaff: {id: 0, name: 'All staff'},
            typeList: [
                {id: 0, name: 'All type'},
                {id: 1, name: 'In'},
                {id: 2, name: 'Out'},
            ],
            filterType: {id: 0, name: 'All type'},
            page_key: 0,
            date_format_string
        }
    },
    methods: {
        changeItemsPerPage() {

        },
        changePage() {

        }
    }
}
</script>